export const DEFAULT_NUMERIC_INPUT_PATTERN = '[0-9]*[.,]?[0-9]*';
export const DEFAULT_NAME_PATTERN = 'A-Za-zА-Яа-яЁё-';
export const DEFAULT_CRYPTO_ADDRESS_PATTERN = 'A-Za-z0-9';
